import { ITranslation } from "./types";

export const pl: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Twój rachunek jest przetwarzany, proszę sprawdź ponownie za kilka minut.<br/>In case of any issues, please reach out through venue support.',
    errorReachOutSupportMsg:
      'In case of any issues, please reach out through venue support.',
  },
  api: {
    E_FORCED_LOGOUT: "Zostałeś wylogowany z powodu braku dostępu.",
  },
  orderStatus: {
    draft: "Oczekuje na płatność",
    contested: "Rozpatrywany",
    paid: "Zapłacony",
    unpaid: "Niezapłacony",
    pending: "Oczekuje na weryfikację",
    reviewed: "Zweryfikowany",
    paymentProcessing: "Przetwarzanie płatności",
    refunded: "Zwrócony",
    unknown: "Nieznany",
  },
  receiptsList: {
    headings: {
      date: "Data",
      time: "Godzina",
      status: "Status",
      total: "Suma",
    },
    action: {
      view: "Otwórz",
    },
    statusTooltip: {
      draft: "Oczekuje na płatność - zamówienie jest przetwarzane",
      paid: "Zapłacone - zamówienie zostało przetworzone i jest opłacone",
      paymentProcessing:
        "Przetwarzanie płatności - zamówienie zostało przetworzone, płatność jest w trakcie realizacji",
      unpaid:
        "Niezapłacone - zamówienie zostało przetworzone, płatność nieudana",
      pending:
        "Oczekuje na weryfikację - kupujący zgłosił błąd, który jest rozpatrywany przez sprzedającego",
      reviewed: "Zweryfikowany - sprzedający zweryfikował zamówienie",
    },
    loadMore: "Załaduj więcej",
    loadingMore: "Ładowanie...",
    showing: "Wyświetlanie",
  },
  receiptDetailScreen: {
    headerTitle: "Szczegóły rachunku",
    subtotal: "Suma",
    taxBreakdown: {
      headers: {
        rate: "%",
        netto: "Netto",
        brutto: "Brutto",
        tax: "Podatek",
        total: "Suma:",
      },
    },
    tax: "Vat",
    taxCRV: "CRV",
    total: "Suma",
    processTime: "Czas przetwarzania",
    date: "Data",
    paymentStatus: "Status płatności",
    orderId: "Numer zamówienia",
    listOfProducts: "Zakupione produkty",
  },
  receiptDetailComplain: {
    reportProblem: "Zgłoś błąd",
    submitReview: "Wyślij do rozpatrzenia",
    confirmTitle: "Paragon wysłany",
    confirmButton: "Zrobione",
    addMissingItem: "Dodaj brakujący przedmiot",
    addMissingItemMessage: "Dodaj wiadomość (opcjonalne)",
    form: {
      email: {
        label: 'Jak możemy się z Tobą skontaktować?',
        placeholder: 'Twój e-mail, np. me@example.com',
        errors: {
          required: 'Adres e-mail jest wymagany.',
          isEmail: 'Nieprawidłowy adres e-mail.',
          inUse: 'Adres e-mail jest już w użyciu.'
        }
      }
    }
  },
  receiptsScreen: {
    label: {
      contested: "Rozpatrywany",
      draft: "Oczekuje na płatność",
      empty: "Pusty",
      paid: "Zapłacony",
      pending: "Oczekuje na weryfikację",
      refunded: "Zwrócony",
      reviewed: "Zmieniony",
      unknown: "Nieznany",
      unpaid: "Niezapłacony",
      paymentProcessing: "Przetwarzanie płatności",
    },
    message: {
      contested: "Zamówienie jest rozpatrywane",
      draft: "Draft message",
      empty: "Empty message",
      paid: "Paid message",
      pending: "Pending message",
      refunded: "Refunded message",
      reviewed: "Reviewed message",
      unpaid: "Zamówienie nadal nie zostało opłacone poprawnie",
      paymentProcessing: "Przetwarzanie płatności",
    },
    minutes: "minut",
    hours: "godziny",
    days: "dni",
  },
  slideModal: {
    close: "Zamknij",
    searchPlaceholder: "Znajdź produkt",
  },
  receiptsHome: {
    receiptPortal: "Rachunki",
    selectPaymentType: "Wybierz metodę płatności, której użyłeś do wejścia do sklepu",
    selectPaymentTypeSubtitle: "Jeśli przyłożyłeś telefon lub smartwatch, wybierz Apple Pay lub Google Pay",
    cardBin: "Pierwsze %{cardBinDigitsCount} cyfr numeru karty (BIN/IIN)",
    last4: "Ostatnie cztery cyfry Twojej metody płatności",
    last4Apple: "Ostatnie cztery cyfry Twojego numery Apple Pay",
    last4Google: "Ostatnie cztery cyfry Twojego numeru Google Pay",
    instructionApple:
      "Znajdź ostatnie cztery cyfry karty Apple Pay w aplikacji Portfel i wpisz je poniżej",
    openWallet: "Otwórz Portfel",
    instructionGoogle:
      "Znajdź ostatnie cztery cyfry karty Google Pay w aplikacji Portfel i wpisz je poniżej",
    instructionExternalId:
      "Znajdź numer referencyjny płatności w aplikacji płatniczej lub na wyciągu bankowym",
    externalIdLabel: "Numer referencyjny płatności",
    externalIdPlaceholder: "",
    expDate: "Data ważności",
    visitDate: "Data Twojej wizyty",
    submit: "Pobierz rachunki",
    registerEmail:
      "Wpisz swój email by otrzymywać powiadomienia o przyszłych rachunkach",
    registerEmailSuccess: "Adres email zapisany pomyślnie.",
    registerEmailFail:
      "Adres email nie został zapisany, ponieważ żaden rachunek nie jest powiązany z wprowadzonymi danymi karty i/lub datą wizyty.",
    unrecognizedError: "An unrecognized error occurred",
    inconclusiveCardInfo: "We can not find your receipt",
    optionalFieldPlaceholder: 'Opcjonalne',
    invalidCaptcha: "Invalid captcha, please try again",
    oasisApiError:
      "We could not connect to the receipts server. Please try again later.",
    orderNotFound: "Zamówienie nie znalezione",
  },
  receiptError: {
    notFound: {
      title: "Nie znaleziono rachunku",
      message: "Nie możemy znaleźć rachunku dla tego zamówienia. Może wygasł, został usunięty lub link może być nieprawidłowy.",
      retry: "Spróbuj ponownie",
      contactSupport: "Skontaktuj się z pomocą",
      goBack: "Wstecz",
    },
    serverError: {
      title: "Coś poszło nie tak",
      message: "To nasza wina. Spróbuj ponownie za chwilę. Jeśli problem będzie się utrzymywał, skontaktuj się z naszym zespołem wsparcia.",
      retry: "Spróbuj ponownie",
      contactSupport: "Skontaktuj się z pomocą",
    },
  },
  notFound: {
    title: "Nie znaleziono strony",
    message: "Coś poszło nie tak lub link może być nieprawidłowy.",
    goHome: "Wróć do strony głównej",
    goBack: "Wstecz",
  },
};
